import type { TextFieldElementProps } from 'react-hook-form-mui';
import { useTranslation } from 'react-i18next';

import { TextField } from './TextField';

type Props = TextFieldElementProps & {
  name: string;
  label?: string;
};

export const EmailField = ({ name, label, ...props }: Readonly<Props>) => {
  const { t } = useTranslation();

  return (
    <TextField {...props} type="email" name={name} label={label ?? t('auth.loginEmail')} required />
  );
};
